export default {
  user_tutor: state => state.user_tutor,
  tutor_location: state => state.tutor_location,
  sidebar_visible: state => state.sidebar_visible,
  navbar_visible: state => state.navbar_visible,
};



// WEBPACK FOOTER //
// ./src/store/user/getters.js